module.exports = __webpack_public_path__ + "static/media/img-63357b94-b2da-11ee-9f55-0a1ea4c5532f.eb72e3b6.png";